<span class="list-status">
  <span class="status-container" *ngFor="let status of statusList, last as isLast">
    <mat-icon *ngIf="status?.iconName" class="icon-status" [ngStyle]="{'color': status?.color}">{{ status?.iconName }}</mat-icon>
    <span class="status-name">{{ status?.name }} {{ isLast ? '' : ',' }}</span>
  </span>
</span>